// extracted by mini-css-extract-plugin
export default {"mainContainer":"PageNotFound_mainContainer__G6tvm","image":"PageNotFound_image__tU1bB","text":"PageNotFound_text__bFurJ"};